import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const NachFailureUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  status, onStatusChange, statusError, setStatusError, statusList,
  cureDate, onCureDateChange, cureDateError, setCureDateError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update Status'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF
      type='select' name='status' label='Status'
      value={status} onChange={onStatusChange} optionList={statusList}
      error={statusError} setError={setStatusError}
    />
    {status === 'close' && (
      <InputDateUI
        context={context}
        name='cureDate'
        label='Cure Date'
        selectedDateISO={cureDate}
        onChange={onCureDateChange}
        error={cureDateError}
        setError={setCureDateError}
      />
    )}

  </ModalFormUI>

export default NachFailureUpdateModalUI
